module.exports = __webpack_public_path__ + "static/toucan-46c023715dbe8ed43a3c65ed22ec872f.png";